'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Utilities = require('./Utilities');

exports.default = {
    getColumnClassName: _Utilities.getColumnClassName,
    paginate: _Utilities.paginate
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTable/TableUtilities/index.js
// module id = 1616
// module chunks = 0